module.exports = __webpack_public_path__ + "img/t2-position.bc2fa5fc.png";